<eda-dialog2
[display]="displayWindow" width="80vw" height="70vh" [overflow]="'auto'"
  (apply)="onApply()" (close)="closeDialog()" [showDuplicate]=true (duplicate)="onDuplicate()">

  <div header class="flex items-center gap-2">
    @if(!editingTitle) {
      <span class="font-semibold text-base">{{ title }}</span>
      <button class="rounded-md p-1 cursor-pointer hover:bg-gray-100" (click)="startEditTitle()" title="Editar nombre">
        <eda-icon name="pencil" class="pointer-events-none"></eda-icon>
      </button>
    } @else {
      <input
        autofocusOnShow
        class="column-dialog-title-input px-2 py-1 bg-gray-100 rounded-md focus:outline-none text-base font-semibold min-w-[200px]"
        [(ngModel)]="editableTitle"
        (keydown.enter)="saveTitle()"
        (keydown.escape)="cancelEditTitle()"
        (focusout)="saveTitle()"
      />
    }
  </div>

  <div content>
    <div class="grid gap-3"
      [ngClass]="{
        'grid-cols-[0.75fr_0.75fr_0.75fr_3.75fr]': showFormatDateSection,
        'grid-cols-[1fr_1fr_4fr]': !showFormatDateSection}
      ">

      <!-- Agregaciones + Rangos + Navegable -->
      <div class="flex flex-col gap-3">

        <div class="section-card">
          <h4 class="section-title" i18n="@@agregacionesH4">Agregaciones</h4>
          <div class="aggregation-list">
            @for (aggregation of aggregationsTypes; track aggregation) {
              @if (getAggName(aggregation.value)) {
                <div class="aggregation-box"
                  (click)="allowedAggregations && addAggregation(aggregation)"
                  [ngStyle]="{'cursor': !allowedAggregations ? 'not-allowed' : 'pointer'}"
                  [ngClass]="aggregation.selected === true ? 'aggregation-active' : 'aggregation-unactive'">
                    <span>{{getAggName(aggregation.value)}}</span>
                </div>
              }
            }
          </div>
        </div>

        <!-- Rangos -->
        @if (selectedColumn.aggregation_type.length === 7) {
          <div class="section-card">
            <h4 class="section-title flex items-center gap-1.5">
              <span i18n="@@rangeTitle">Rangos</span>
              <i class="pi pi-info-circle text-gray-400 cursor-pointer font-normal normal-case tracking-normal"
                style="font-size: 0.8rem; letter-spacing: 0;"
                [pTooltip]="availableRange ? ptooltipViewTextRanges : ptooltipNotAvailableRanges">
              </i>
            </h4>

            @if (availableRange) {
              <input
                type="text"
                class="w-full border border-gray-300 rounded-md px-2 py-1 text-sm mb-2"
                [(ngModel)]="rangeString"
                [disabled]="showRange"
                (input)="validateInput($event)">

              <button
                class="confirm-button w-full justify-center"
                (click)="addRange(rangeString)"
                [disabled]="(!rangeString || rangeString.length === 0) || showRange">
                <span i18n="@@addRange">Añadir Rango</span>
              </button>

              @if (showRange) {
                <div class="mt-2">
                  <p-scrollPanel [style]="{width: '100%', height: '120px'}" styleClass="custombar1">
                    <div class="pt-2 text-sm">
                      <b i18n="@@rangeDescriptionB" class="mr-2">• Rango:</b>
                      <i class="pi pi-times cursor-pointer float-right text-gray-400 hover:text-red-500" (click)="removeRange()"></i>
                      <div [innerHTML]="selectedRange" class="px-4 py-1"></div>
                    </div>
                  </p-scrollPanel>
                </div>
              }
            }
          </div>
        }

        <!-- Navegable -->
        @if (selectedColumn.column_type === 'date') {
          <div class="section-card">
            <h4 class="section-title" i18n="@@dateNavLabel">Navegación por fecha</h4>
            <p-inputSwitch
              id="dateNavEnabled"
              [(ngModel)]="dateNavEnabled"
              (onChange)="handleDateNavEnabled()">
            </p-inputSwitch>
          </div>
        }
        @if (selectedColumn.column_type === 'text' || (selectedColumn.column_type === 'date' && !dateNavEnabled)) {
          <div class="section-card">
            <h4 class="section-title" i18n="@@navegableFrom">Navegable desde</h4>
              <p-dropdown
              [options]="childOptions"
              [(ngModel)]="selectedParent"
              optionLabel="label"
              optionValue="value"
              [autoDisplayFirst]="false"
              [showClear]="true"
              [disabled]="childOptions.length === 0"
              i18n-placeholder="@@noParentText"
              placeholder="Sin padre"
              [style]="{'width': '100%'}"
              appendTo="body">
            </p-dropdown>
              @if(childOptions.length === 0) {
              <small class="text-gray-400 text-xs mt-1 block" i18n="@@noParentAttributes">Añade más atributos para activar la navegación</small>
            }
          </div>
        }

      </div>

      <!-- Ordenación -->
      <div class="section-card self-start">
        <h4 class="section-title" i18n="@@ordenacionH4">Ordenación</h4>
        <div class="aggregation-list">
          @for (ordenation of ordenationTypes; track ordenation) {
            <div class="aggregation-box"
              (click)="addOrdenation(ordenation)"
              [ngClass]="ordenation.selected === true ? 'aggregation-active' : 'aggregation-unactive'">
              <span>{{ordenation.display_name | uppercase}}</span>
            </div>
          }
        </div>
      </div>

      <!-- FormatDate -->
      @if (showFormatDateSection) {
        <div class="section-card self-start">
          <h4 class="section-title" i18n="@@dateFormatH4">Formato</h4>

          @if (selectedColumn.computed_column === 'computed') {
            <div class="p-message p-message-info rounded p-2 mb-3 text-sm">
              <i class="pi pi-exclamation-triangle mr-2"></i>
              <span i18n="@@noFormatsAvailable">Esta es una columna calculada y no tiene opciones de formato disponibles</span>
            </div>
          }

          <p-dropdown
            [style]="{width:'100%'}"
            [(ngModel)]="formatDate"
            [options]="formatDates"
            [optionLabel]="'display_name'"
            [autoDisplayFirst]="false"
            [showClear]="true"
            (onChange)="addFormatDate()"
            appendTo="body"
            styleClass="w-full">
          </p-dropdown>

          <div class="mt-4" [pTooltip]="cumulativeSumTooltip" tooltipPosition="left">
            <p class="text-xs font-semibold text-gray-500 mb-1" i18n="@@cumulativeSum">Suma acumulativa</p>
            <p-inputSwitch
              id="cumulativeSum"
              [(ngModel)]="cumulativeSum"
              (onChange)="handleCumulativeSum()"
              [disabled]="!cumulativeSumAllowed()">
            </p-inputSwitch>
          </div>
        </div>
      }

      <!-- Filtrar -->
      <div class="flex flex-col gap-3">

        <div class="section-card">
          <h4 class="section-title" i18n="@@filtrarH4">Filtrar</h4>
          <div class="grid grid-cols-[42.5%_42.5%_15%] gap-3 items-start">

            <!-- Tipo y ámbito de filtro + switch -->
            <div class="flex flex-col gap-3 w-full">
              <p-dropdown id="types" [options]="filter.types" [(ngModel)]="filterSelected" optionLabel="label"
                [autoDisplayFirst]="false" [style]="{'width': '100%'}" [showClear]="true"
                i18n-placeholder="@@tiposFiltrosLabel" placeholder="Tipos de filtro"
                (onChange)="handleFilterChange(filterSelected)">
              </p-dropdown>

              @if (filterSelected && selectedColumn?.column_type === 'numeric' && !display.switchButton && aggregationSelected?.value !== 'none') {
                <p-dropdown
                  id="whereHaving"
                  [options]="filterBeforeAfter.elements"
                  [(ngModel)]="filterBeforeAfterSelected"
                  optionLabel="label"
                  [autoDisplayFirst]="true"
                  [style]="{'width': '100%'}"
                  i18n-placeholder="@@whereHavingLabel" placeholder="Ámbito del filtro"
                  (onChange)="whereHavingSwitch(filterBeforeAfterSelected)">
                </p-dropdown>
              }

              @if (!showFormatDateSection) {
                <div class="flex items-center gap-2">
                  <label class="text-base text-gray-600" i18n="@@optionsLabel" for="filter_options">Opciones</label>
                  <p-inputSwitch id="filter_options" [(ngModel)]="filter.switch" [disabled]="display.switchButton"
                    (onChange)="loadDropDrownData()">
                  </p-inputSwitch>
                </div>
              }
            </div>

            <!-- Valores de los filtros -->
            <div class="flex flex-col w-full gap-3">
              @if (!!display.calendar && !!display.between) {
                <eda-date-picker #myCalendar class="h-[3.2rem]" (onDatesChanges)="processPickerEvent($event)"></eda-date-picker>
              }
              @if (!(display.calendar && display.between) && !filter.switch && (!['not_null', 'not_null_nor_empty', 'null_or_empty'].includes(filterSelected?.value))) {
                @if(selectedColumn?.column_type === 'date') {
                  <div class="date-picker-single">
                    <eda-date-picker
                      (onDatesChanges)="processPickerEvent($event)"
                      [filterSelected]="filterSelected"
                      [selectionMode]="'single'">
                    </eda-date-picker>
                  </div>
                }
                @if(!showFormatDateSection){
                  <input
                    id="float-input1"
                    class="w-full h-[3.2rem] rounded-md border border-gray-300 px-3 py-2"
                    [type]="inputType"
                    [(ngModel)]="filterValue.value1"
                    (input)="handleValidForm({ value1: filterValue.value1 })"
                    i18n-placeholder="@@valor1Label" placeholder="Valor 1"
                    pInputText
                  />
                }
              }
              @if (filter.switch) {
                <div class="w-full h-[3.2rem] [&_.p-multiselect]:h-full [&_.p-multiselect-label-container]:h-full [&_.p-multiselect-label-container]:flex [&_.p-multiselect-label-container]:items-center">
                  <p-multiSelect
                    [options]="dropDownFields"
                    [(ngModel)]="filterValue.value1"
                    [virtualScroll]="true"
                    [itemSize]="34"
                    [filter]="true"
                    [style]="{width:'100%', height:'100%'}"
                    [panelStyle]="{minWidth:'100%'}"
                    (onChange)="handleValidForm({value1: filterValue.value1})"
                    i18n-defaultLabel="@@groupSelect"
                    defaultLabel="Selecciona..."
                    [loading]="loading"
                    [selectionLimit]="limitSelectionFields"
                    id="float-input1">
                  </p-multiSelect>
                </div>
              }
              @if (!!display.between) {
                @if (!display.calendar && !filter.switch) {
                  <input id="float-input2" class="h-[3.2rem] w-full rounded-md border border-gray-300 px-3 py-2" [type]="inputType"
                    [(ngModel)]="filterValue.value2" (input)="handleValidForm({value2: filterValue.value2})"
                    i18n-placeholder="@@valor2Label" placeholder="Valor 2" pInputText>
                }
                @if (filter.switch) {
                  <div class="w-full h-[3.2rem] [&_.p-multiselect]:h-full [&_.p-multiselect-label-container]:h-full [&_.p-multiselect-label-container]:flex [&_.p-multiselect-label-container]:items-center">
                    <p-multiSelect [options]="dropDownFields" [(ngModel)]="filterValue.value2" [virtualScroll]="true" [itemSize]="34"
                      [filter]="true" [style]="{width:'100%', height:'100%'}" [panelStyle]="{minWidth:'100%'}"
                      (onChange)="handleValidForm({value2: filterValue.value2})" i18n-defaultLabel="@@groupSelect" defaultLabel="Selecciona..."
                      [selectionLimit]="limitSelectionFields" id="float-input2">
                    </p-multiSelect>
                  </div>
                }
              }
            </div>

            <!-- Botón añadir filtro -->
            <div>
              <button class="addFilter-button" (click)="addFilter()" [disabled]="display.filterButton">
                <i class="fa fa-plus mr-1"></i>
                <span i18n="@@addFilterBtn">Añadir filtro</span>
              </button>
            </div>

          </div>
        </div>

        <!-- Lista de filtros activos -->
        @if (filter.forDisplay.length > 0) {
          <div class="section-card pt-3">
            <h5 class="section-title" i18n="@@filters">Filtros activos</h5>
            <div class="w-full h-auto max-h-[23vh] overflow-auto rounded-md border border-gray-200">
              <p-scrollPanel styleClass="custombar1">
                @for (filtre of filter.forDisplay; track filtre) {
                  <div class="filter-tag flex items-center justify-between px-3 py-2">
                    <span class="text-base">
                      @if (filtre.filter_elements.length === 0) {
                        * {{ selectedColumn.display_name.default }} is {{ filtre.filter_type }}
                      }
                      @if (filtre.filter_elements.length === 1) {
                        * {{ selectedColumn.display_name.default }} {{ filtre.filter_type }} "{{ filtre.filter_elements[0].value1 }}"
                      }
                      @if (filtre.filter_elements.length === 2) {
                        * {{ selectedColumn.display_name.default }} {{ filtre.filter_type }} "{{ filtre.filter_elements[0].value1 }}" Y "{{ filtre.filter_elements[1].value2 }}"
                      }
                    </span>
                    <div class="flex items-center gap-2 ml-2 shrink-0">
                      <span class="text-base text-gray-500 whitespace-nowrap">
                        {{ filtre.filterBeforeGrouping ? whereMessage : havingMessage }}
                      </span>
                      <i class="pi pi-times cursor-pointer text-gray-400 hover:text-red-500 text-xs" (click)="removeFilter(filtre)"></i>
                    </div>
                  </div>
                }
              </p-scrollPanel>
            </div>
          </div>
        }

      </div>

    </div>
  </div>
</eda-dialog2>

@if(display.duplicateColumn){
  <eda-dialog2 header="Duplicar columna" width="40vw" height="auto" (close)="onCancelDuplicateColumn()" (apply)="saveDuplicatedColumn()">
    <div content class="p-4 space-y-2">
      <label i18n="@@duplicatedColumnNameLabel" for="duplicatedColumnName" class="block text-base font-medium text-gray-700">
        Nombre columna duplicada
      </label>
      <input
        id="duplicatedColumnName"
        type="text"
        [(ngModel)]="duplicatedColumnName"
        class="w-full rounded-md border border-gray-300 bg-white px-3 py-2.5 text-base text-gray-900 focus:outline-none focus:border-[var(--corporate-primary)]"
      />
    </div>
  </eda-dialog2>
}
